/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { exportGiayTo } from "../../services/exportFileServices";
import { exportToFile, formatDateTable, hasAuthority } from "../../utils/functionUtils";
import { INIT_GIAY_TO_DINH_KEM, REF_TAB } from "../constants/profileConsts";
import { IGiayToDinhKemInfo } from "../models/profileModels";
import { deleteGiayToDinhKem, getAllGiayToDinhKemById } from "../services/dialogServices";
import TempPapersDialog from "./dialogs/TempPapersDialog";
import TableCustom from "../../components/table-custom/TableCustom";
import { EXPORT_FILE_NAME, RESPONSE_STATUS_CODE, TYPE } from "../../constants/moduleConsts";
import { PERMISSIONS, PERMISSION_ABILITY } from "../../../constants";
import useMultiLanguage from "../../../hook/useMultiLanguage";
import AppContext from "../../../AppContext";

export const TempPapersInformation = (props: any) => {
  const { identify, isView, employeeProfiles, activeTab } = props;
  const [shouldOpenTempPapers, setShouldOpenTempPapers] = useState<boolean>(false);
  const [tempPapers, setTempPapers] = useState<IGiayToDinhKemInfo>(INIT_GIAY_TO_DINH_KEM);
  const [listTempPapers, setListTempPapers] = useState<IGiayToDinhKemInfo[]>([]);
  const { setPageLoading } = useContext(AppContext);

  const { lang } = useMultiLanguage();

  useEffect(() => {
    if (!(identify && activeTab === REF_TAB.TT_KHAC)) return
    updateDataTempPapers();
  }, [employeeProfiles, activeTab]);

  const handleOpenTempPapers = (data: IGiayToDinhKemInfo): void => {
    setTempPapers(data);
    setShouldOpenTempPapers(true);
  };

  const handleCloseTempPapers = (): void => {
    setShouldOpenTempPapers(false);
    setTempPapers(INIT_GIAY_TO_DINH_KEM);
  };
  
  const handleCloseAndSearch = () => {
    updateDataTempPapers();
    handleCloseTempPapers();
  }

  const updateDataTempPapers = async () => {
    if (identify) {
      try {
        const { data } = await getAllGiayToDinhKemById(identify);
        if(data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
          setListTempPapers(data?.data);
        } else {
          toast.warning(data?.message);
        }
      } catch (error: any) {
        toast.error(error);
      }
    }
  };

  const handleDelete = async (ids: string[]) => {
    try {
      const { data } = await deleteGiayToDinhKem(ids)
      if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
        toast.success(lang("GENERAL.DELETE_SUCCESS"))
        updateDataTempPapers();
        return true;
      } else {
        toast.warning(data?.message);
      }
    } catch (error) {
      toast.error(lang("GENERAL.ERROR"));
    }
  }

  const columns = [
    {
      name: "STT",
      field: "",
      render: (row: any, index: number, stt: number) => <span>{stt}</span>
    },
    {
      name: lang("GENERAL.INFO.TEMP.PAPERS.NAME"),
      field: "tenGiayTo",
      headerStyle: {
        minWidth: "200px"
      },
      cellStyle: {
        minWidth: "200px",
        maxWidth: "200px",
        textAlign: "left",
      },
      render: (row: any) => <span>{row?.tenGiayTo?.name}</span>
    },
    {
      name: lang("INPUT.DATERANGE"),
      field: "ngayCap",
      headerStyle: {
        minWidth: "100px"
      },
      cellStyle: {
        minWidth: "100px",
        maxWidth: "100px",
        textAlign: "left",
      },
      render: (row: any) => <span>{formatDateTable(row?.ngayCap)}</span>
    },
    {
      name: lang("INPUT.EXPIRATIONDATE"),
      field: "ngayHetHan",
      headerStyle: {
        minWidth: "130px"
      },
      cellStyle: {
        minWidth: "130px",
        maxWidth: "130px",
        textAlign: "left",
      },
      render: (row: any) => <span>{formatDateTable(row?.ngayHetHan)}</span>
    },
    {
      name: lang("INPUT.PLACERANGE"),
      field: "noiCap",
      headerStyle: {
        minWidth: "200px"
      },
      cellStyle: {
        minWidth: "200px",
        maxWidth: "200px",
        textAlign: "left",
      },
    },
    {
      name: lang("ALLOWANCE.NOTE"),
      field: "ghiChu",
      headerStyle: {
        minWidth: "200px"
      },
      cellStyle: {
        minWidth: "200px",
        maxWidth: "200px",
        textAlign: "left",
      },
    },
  ]

  return (
    <>
      <div className="form-info">
        <div className="block-content">
          <TableCustom
            id="listTempPapers"
            title={lang("GENERAL.INFO.TEMP.PAPERS")}
            isActionTableTab
            data={listTempPapers}
            columns={columns}
            type={TYPE.MULTILINE}
            fixedColumnsCount={2}
            noToolbar={true}
            noPagination={true}
            handleDoubleClick={handleOpenTempPapers}
            handleDelete={handleDelete}
            dependencies={activeTab}
            buttonAdd={!isView && hasAuthority(PERMISSIONS.EMPLOYEE, PERMISSION_ABILITY.UPDATE)}
            buttonExportExcel={hasAuthority(PERMISSIONS.EMPLOYEE, PERMISSION_ABILITY.VIEW)}
            handleOpenDialog={() => setShouldOpenTempPapers(true)}
            handleExportExcel={() => 
              exportToFile({
                exportAPI: () => exportGiayTo(employeeProfiles.id), 
                fileName: EXPORT_FILE_NAME.GIAY_TO,
                setPageLoading
              })
            }
          />
        </div>
        {shouldOpenTempPapers && (
          <TempPapersDialog
            handleCloseTempPapersDialog={handleCloseTempPapers}
            handleCloseAndSearch={handleCloseAndSearch}
            identify={props.identify}
            isView={isView}
            tempPapersEdit={tempPapers}
          />
        )}
      </div>
    </>
  );
};
